export default {"emptyReviews":"MQXFY","content":"osYeV"};